var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape4 = function SvgShape4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 81,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M169.619 40.67c3.694 6.4 5.541 9.6 6.474 12.942a27.5 27.5 0 0 1 0 14.776c-.933 3.343-2.78 6.542-6.474 12.942l-11.254 19.497c-3.695 6.4-5.542 9.599-7.97 12.079a27.47 27.47 0 0 1-12.795 7.389c-3.361.863-7.055.863-14.444.863H54.844c-7.39 0-11.083 0-14.445-.863a27.46 27.46 0 0 1-12.795-7.389c-2.428-2.479-4.275-5.679-7.969-12.079L8.381 81.33c-3.694-6.4-5.541-9.6-6.475-12.942a27.5 27.5 0 0 1 0-14.776c.934-3.343 2.78-6.542 6.475-12.942l11.254-19.497c3.694-6.4 5.541-9.6 7.97-12.08a27.47 27.47 0 0 1 12.794-7.388C43.76.842 47.455.842 54.843.842h68.313c7.389 0 11.083 0 14.444.863a27.47 27.47 0 0 1 12.795 7.389c2.428 2.48 4.275 5.68 7.97 12.08z",
    opacity: 0.1
  })));
};
export default SvgShape4;